import ActionType from '@actions/type';

export function setDsStatus(data) {
  return {
    type: ActionType.DS_SET,
    status: data,
  };
}



// WEBPACK FOOTER //
// ./actions/dsStatus.js